export default __webpack_public_path__ + "static/media/B3.c5b1637d.png";